import { IntlConfig, ReactIntlErrorCode } from "react-intl";

/**
 * react-intl v3+ reports every missing translation through onError, which
 * floods the console for partially translated locales. A missing id already
 * falls back to the English defaultMessage, so only surface other errors.
 */
export const intlOnError: IntlConfig["onError"] = (err) => {
  if (err.code === ReactIntlErrorCode.MISSING_TRANSLATION) {
    return;
  }
  console.error(err);
};
